import React, { Component } from 'react';
import _get from 'lodash/get';
import _size from 'lodash/size';

class Testimonial extends Component {
  ref = React.createRef();

  componentDidMount() {
    const { observer = {} } = this.props;
    observer.observe(this.ref.current);
  }

  render() {
    const testimonials = _get(this.props, 'faqAndTestimonial.testimonial', []);
    const inlineStyle = _size(testimonials)
      ? {}
      : {
          display: 'none'
        };
    return (
      <div className="testimonial" id="testimonial" ref={this.ref} style={inlineStyle}>
        {testimonials.map(({ image, content }) => (
          <div key={image} className="card">
            <div className="profile">
              <img src={image} className="image" />
            </div>
            <div className="content">{content}</div>
          </div>
        ))}
      </div>
    );
  }
}

export default Testimonial;
